var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2503_1956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.62507 22.0001C2.46673 22.0001 2.30423 21.9376 2.1834 21.8167C1.93757 21.5709 1.93757 21.1751 2.1834 20.9334L20.9334 2.1834C21.1792 1.93757 21.5751 1.93757 21.8167 2.1834C22.0626 2.42923 22.0626 2.82507 21.8167 3.06673L3.06673 21.8167C2.9459 21.9376 2.7834 22.0001 2.62507 22.0001Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3751 22.0001C21.2167 22.0001 21.0542 21.9376 20.9334 21.8167L2.1834 3.06673C1.93757 2.82507 1.93757 2.42507 2.1834 2.1834C2.42923 1.93757 2.8209 1.93757 3.06673 2.1834L21.8167 20.9334C22.0626 21.1792 22.0626 21.5751 21.8167 21.8167C21.6959 21.9376 21.5334 22.0001 21.3751 22.0001Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_1956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.fc170db12362ef28ab63184a6ebd3c8d.svg";
export { ForwardRef as ReactComponent };